<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <app-logo />
      </b-link>
      <auth-locale />
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Reset password"
          />
        </div>
      </b-col>
      <!-- /Left Text-->
      <!-- Reset password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('auth.reset.title') }}
          </b-card-title>
          <b-card-text
            v-if="!token"
            class="mb-2 text-danger"
          >
            {{ $t('auth.reset.invalidLink') }}
          </b-card-text>

          <!-- form -->
          <validation-observer
            v-if="token"
            ref="simpleRules"
          >
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                :label="$t('auth.fields.newPassword')"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('auth.fields.newPassword')"
                  vid="password"
                  rules="required|min:8"
                >
                  <b-form-input
                    id="reset-password-new"
                    v-model="password"
                    type="password"
                    autocomplete="new-password"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                :label="$t('auth.fields.newPasswordConfirm')"
                label-for="reset-password-confirm"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('auth.fields.newPasswordConfirm')"
                  rules="required|confirmed:password"
                >
                  <b-form-input
                    id="reset-password-confirm"
                    v-model="passwordConfirm"
                    type="password"
                    autocomplete="new-password"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="saving"
              >
                {{ $t('auth.reset.submit') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('auth.signInPrompt') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, min, confirmed } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import AppLogo from '@core/layouts/components/Logo.vue'
import AuthLocale from '@/layouts/components/AuthLocale.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    AppLogo,
    AuthLocale,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
      saving: false,
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      min,
      confirmed,
    }
  },
  computed: {
    token() {
      return this.$route.query.token
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.resetPassword()
        }
      })
    },
    resetPassword() {
      this.saving = true
      this.$store.dispatch('users/resetPassword', {
        token: this.token,
        password: this.password,
      })
        .then(response => {
          const status = Boolean(response && response.status)
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('auth.forgot.toastTitle'),
              icon: 'InfoIcon',
              variant: status ? 'success' : 'danger',
              text: response ? response.message : this.$t('auth.reset.technicalError'),
            },
          })
          if (status) {
            this.$router.replace({ name: 'auth-login' })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.brand-logo{
  min-width: 80px !important;
  min-height: 80px !important;
}
.brand-logo svg{
  min-width: 80px !important;
  min-height: 80px !important;
}
</style>
